import { useState, useMemo } from "react";

const useToggle = (initial = false) => {
  const [value, setValue] = useState(initial);

  const actions = useMemo(
    () => ({
      toggle: () => setValue((prev) => !prev),
      off: () => setValue(false),
      on: () => setValue(true),
    }),
    [],
  );

  return [value, actions];
};

export default useToggle;
